import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-463f2b35"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-5 text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spin fa-spinner me-3" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Loading...")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Specify any actions you want to execute when assets are about to expiry.", -1))
const _hoisted_7 = { class: "action-label" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Update asset visibility")
const _hoisted_9 = { class: "action-settings" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Make asset visible for user group: ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "action-label" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Update asset name")
const _hoisted_15 = { class: "action-settings" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Content:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Place:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "prefix" }, "Prefix", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "suffix" }, "Suffix", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "replace" }, "Replace", -1))
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "action-label" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Update asset description")
const _hoisted_24 = { class: "action-settings" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Content:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Place:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "prefix" }, "Prefix", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "suffix" }, "Suffix", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "replace" }, "Replace", -1))
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", {
            class: _normalizeClass(["action", _ctx.actions.updateVisibility.enabled ? '' : 'disabled'])
          }, [
            _createElementVNode("label", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.actions.updateVisibility.enabled) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.actions.updateVisibility.enabled]
              ]),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.actions.updateVisibility.userGroup) = $event))
              }, [
                _hoisted_11,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userGroups, (grp, grpIdx) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: grpIdx,
                    value: grp.id
                  }, _toDisplayString(grp.groupName), 9, _hoisted_12))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.actions.updateVisibility.userGroup]
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["action", _ctx.actions.updateName.enabled ? '' : 'disabled'])
          }, [
            _createElementVNode("label", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.actions.updateName.enabled) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.actions.updateName.enabled]
              ]),
              _hoisted_14
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.actions.updateName.content) = $event))
              }, null, 512), [
                [_vModelText, _ctx.actions.updateName.content]
              ]),
              _hoisted_17,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.actions.updateName.place) = $event))
              }, _hoisted_21, 512), [
                [_vModelSelect, _ctx.actions.updateName.place]
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["action", _ctx.actions.updateDescription.enabled ? '' : 'disabled'])
          }, [
            _createElementVNode("label", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.actions.updateDescription.enabled) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.actions.updateDescription.enabled]
              ]),
              _hoisted_23
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.actions.updateDescription.content) = $event))
              }, null, 512), [
                [_vModelText, _ctx.actions.updateDescription.content]
              ]),
              _hoisted_26,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.actions.updateDescription.place) = $event))
              }, _hoisted_30, 512), [
                [_vModelSelect, _ctx.actions.updateDescription.place]
              ])
            ])
          ], 2)
        ]))
  ]))
}